import axios from "axios";
import auth from "./auth"

var config = require("../conf.json");

const BASE_URL = config.server;

export {deleteTrainer,activateUser, getKITrainer, postKITrainer, getMainEmphases, getIndustrySectors, getTechnologies, uploadI,postEmphasis};

function getKITrainer(){
    const url = BASE_URL + config.kitrainer+"/get";
    return axios
    .get(url, { headers: getAuthHeader() })
    .then(response => response.data);
}

function deleteTrainer(){
  const url = BASE_URL + config.kitrainer+"/delete";
    return axios
    .get(url, { headers: getAuthHeader() })
    .then(response => response.data);
}

function postKITrainer(data){
  console.log(data)
  const url = BASE_URL + config.kitrainer+"/create";
  return axios
  .post(url,data, { headers: getAuthHeader() })
  .then(response => response.data);
}

/*function checkKITrainer(data){
  const url = BASE_URL + config.kitrainer+"/check/"+data;
  return axios
  .get(url, { headers: getHeader() })
  .then(response => response.data);
}*/

function postEmphasis(data){
  const url = BASE_URL + config.mainemphases+"/create";
  return axios
  .post(url,data, { headers: getHeader() })
  .then(response => response.data);
}

function getMainEmphases(){
  const url = BASE_URL + config.mainemphases;
  return axios
  .get(url, { headers: getHeader() })
  .then(response => response.data);
}

function getIndustrySectors(){
  const url = BASE_URL + config.industrysector;
  return axios
  .get(url, { headers: getHeader() })
  .then(response => response.data);
}

function getTechnologies(){
  const url = BASE_URL + config.technology;
  return axios
  .get(url, { headers: getHeader() })
  .then(response => response.data);
}

function uploadI(file) {
  const url = BASE_URL + config.image;
  return axios.post(url, file, { headers: getImageHeader() }).then(res => res.data)
}

function activateUser(hash) {
  const url = BASE_URL + config.user + "/activate/" + hash;
  return axios.get(url).then(response => response.data);
}


/*
function getHeader() {
    let headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    };
    return headers;
  }

  function getAuthHeader() {
    let headers = {
      Authorization: "Bearer " + auth.getToken(),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    };
    return headers;
  }
  */

  function getAuthHeader() {
    let headers = {
      Authorization: "Bearer " + auth.getToken()
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    };
    return headers;
  }
  
  function getHeader() {
    let headers = {
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    };
    return headers;
  }

  function getImageHeader() {
    let headers = {
      "Content-Type": "image/jpeg"//,
      //"Access-Control-Allow-Origin": "*",
      //"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    };
    return headers;
  }
